/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceIncidentConfigurationMappingForBudgetAlerts extends models.FreshserviceIncidentConfigurationMappingBase {
    getFixupPrototypeFunction() { return FreshserviceIncidentConfigurationMappingForBudgetAlerts.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceIncidentConfigurationMappingForBudgetAlerts>): FreshserviceIncidentConfigurationMappingForBudgetAlerts {
        let obj = Object.assign(new FreshserviceIncidentConfigurationMappingForBudgetAlerts(), model);
        FreshserviceIncidentConfigurationMappingForBudgetAlerts.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceIncidentConfigurationMappingForBudgetAlerts>): FreshserviceIncidentConfigurationMappingForBudgetAlerts {
        if (!model) return null;
        return FreshserviceIncidentConfigurationMappingForBudgetAlerts.newInstance(<FreshserviceIncidentConfigurationMappingForBudgetAlerts> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceIncidentConfigurationMappingForBudgetAlerts) {
        if (!obj) return;

        models.FreshserviceIncidentConfigurationMappingForBudgetAlerts.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceIncidentConfigurationMappingForBudgetAlerts): boolean {
        if (models.FreshserviceIncidentConfigurationMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FreshserviceIncidentConfigurationMappingForBudgetAlerts.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed attributes for Budget Alerts Description
     */
    value: models.DescriptionAttributeForItsmBudgetAlert;

    value_direct: string;

}
